import FreelancerTags from ".";

export const freelancerTagsRoutes = () => [
  {
    path: "/admin/freelancer-tags",
    component: FreelancerTags,
    layout: "admin",
    routeType: "admin",
    title: "Freelancers Management",
  },
];
